import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const getEmployeesStart = () => {
    return {
      type: actionTypes.GET_EMPLOYEES_START
    };
  };

export const getEmployeesSuccess=(employees)=>{
    return {
        type:actionTypes.GET_EMPLOYEES_SUCCESS,
        employees:employees
    }
}
export const getEmployeesFail=(error)=>{
    return {
        type:actionTypes.GET_EMPLOYEES_FAIL,
        error:error
    }
}

export const getEmployees = (token) => {
    return async dispatch => {
      //employee list
      dispatch(getEmployeesStart());
      let url =`${api}/users`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{}
          };
          await axios(options)
          .then(response => {
          dispatch(getEmployeesSuccess(response.data));
        })
        .catch(err => {
          dispatch(getEmployeesFail(`get employees failed - ${err}`));
        });
    };
  };

  export const clearData=()=>{
      return {
          type:actionTypes.CLEAR_DATA,
          employees:[]
      }
  }

  export const createEmployeeStart=()=>{
      return {
          type:actionTypes.CREATE_EMPLOYEE_START
      }
  }

  export const createEmployeeSuccess=(successMessage)=>{
      return {
          type:actionTypes.CREATE_EMPLOYEE_SUCCESS,
          message:successMessage
      }
  }

  export const createEmployeeFail=(errorMessage)=>{
      return {
          type:actionTypes.CREATE_EMPLOYEE_FAIL,
          error:errorMessage
      }
  }

  export const createEmployee=(employee,token)=>{
      return async dispatch =>{
          dispatch(createEmployeeStart());
          let url =`${api}/users`;
          const options = {
              url: url,
              method: 'POST',
              headers: {
                  'Authorization': 'Bearer '+token
               },
              data:employee
            };
           await axios(options)
            .then(response => {
            dispatch(createEmployeeSuccess('Successfully created the user'));
            dispatch(getEmployees(token));
          })
          .catch(err => {
            dispatch(createEmployeeFail('User Creation Failed'));
          });
      }
  }
  
export const openEditForm=(employee)=>{
    return {
        type:actionTypes.OPEN_EDIT_FORM,
        editEmployee:employee,
    }
}

export const closeEditForm=()=>{
    return {
        type:actionTypes.CLOSE_EDIT_FORM,
    }
}

export const clearEdit=()=>{
    return {
        type:actionTypes.CLEAR_EDIT
    }
}

export const updateUserStart=()=>{
    return {
        type:actionTypes.UPDATE_EMPLOYEE_START
    }
}
export const updateUserSuccess=(successMessage)=>{
    return {
        type:actionTypes.UPDATE_EMPLOYEE_SUCCESS,
        message:successMessage
    }
}

export const updateUserFail=(errorMessage)=>{
    return {
        type:actionTypes.UPDATE_EMPLOYEE_FAIL,
        error:errorMessage
    }
}
export const updateUser=(user,token)=>{
    return async dispatch=>{
      dispatch(updateUserStart());
      let url =`${api}/users/${user.id}`;
          const options = {
              url: url,
              method: 'PUT',
              headers: {
                  'Authorization': 'Bearer '+token
               },
              data:{
                  'name':user.name,
                  'username':user.username,
                  'roles':user.roles,
              }
            };
           await axios(options)
            .then(response => {
            dispatch(updateUserSuccess('Updating User Success'));
            dispatch(getEmployees(token));
          })
          .catch(err => {
            dispatch(updateUserFail(`User update Failed - ${err}`));
          });
    }
}
